export interface UserAccount {
  id: string;
  unique_id: string;
  email: string;
  name: string;
  last_name: string;
  latin_name: string;
  latin_lastname: string;
  birthdate: string; // TypeScript requires type assertions to avoid type errors
  country: string;
  city: string;
  mobile_number: string;
  nationality: string;
  gender: number; // 0 = male, 1 = female
  is_activated: boolean;
  is_mobileVerified: boolean;
  is_premium: boolean;
  activation_code: number;
  is_verified: boolean;
  profile_completed: boolean;
  last_login: string;
  registration_date: string;
  password: string;
  confirm_password: string;
  authentication: string;
  verificationCode: string;
  friendStatus?: number;
}

export interface ConnectedPeopleInterface {
  request_id: string;
  sender_id: string;
  receiver_id: string;
  request_date: string;
  status: number;
  user_id: string;
  name: string;
  last_name: string;
  email: string;
  country: string;
  city: string;
  mobile_number: string;
  gender: number;
}

export class DefaultUserAccount implements UserAccount {
  id = '';
  unique_id = '';
  email = '';
  name = '';
  last_name = '';
  latin_name = '';
  latin_lastname = '';
  birthdate = '';
  country = '';
  city = '';
  mobile_number = '';
  nationality = '';
  gender = 1;
  is_activated = false;
  is_premium = false;
  activation_code = 0;
  is_verified = false;
  is_mobileVerified = false;
  profile_completed = false;
  last_login = '';
  registration_date = '';
  password = '';
  confirm_password = '';
  authentication = '';
  verificationCode = '';
  friendStatus = 0;

  constructor() {
    // You can provide default values or leave them as empty strings, 0, or false
  }
}
